import React, { useState, useEffect, createContext } from 'react';
import { Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import Home from './components/Home';
import Dashboard from './components/Dashboard';
import Login from './components/Login';
import Modal from './components/Modal';
import './App.scss';

export const AuthContext = createContext();

function App() {
  const [user, setUser] = useState(null);
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [registrations, setRegistrations] = useState([])

  const location = useLocation();
  const navigate = useNavigate(); // Ավելացրինք նավիգացիան

  useEffect(() => {
    const savedUser = localStorage.getItem('adminUser');
    if (savedUser) setUser(JSON.parse(savedUser));
    setLoading(false);
  }, []);

  const handleLogin = (userData) => {
    setUser(userData);
    localStorage.setItem('adminUser', JSON.stringify(userData));
    setIsAuthModalOpen(false);

    // Երբ լոգինը հաջողվում է, ավտոմատ տեղափոխում ենք դաշբոարդ
    navigate('/admin-dashboard');
  };

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem('adminUser');
    navigate('/'); // Ելքից հետո վերադառնում ենք գլխավոր էջ
  };

  const getCurrentSectionId = () => {
    const pathParts = location.pathname.split('/');
    if (pathParts[1] === 'education') return pathParts[2];
    return null;
  };

  if (loading) return <div className="loader">Բեռնվում է...</div>;

  return (
    <AuthContext.Provider value={{
      user,
      handleLogin,
      handleLogout,
      setIsModalOpen: setIsAuthModalOpen,
      registrations,      // Տվյալները
      setRegistrations ,   // Ֆունկցիան, որը թարմացնում է տվյալները (ՍԱ ՊԱՐՏԱԴԻՐ Է)
      navigate
    }}>
      <div className="App">
        <Routes>
          {/* Եթե ադմին է, հիմնական էջը կարող է լինել Dashboard-ը, կամ մնալ Home */}
          <Route path="/*" element={<Home />} />

          {/* Dashboard-ը կբացվի ՄԻԱՅՆ եթե user-ը գոյություն ունի */}
          <Route
            path="/admin-dashboard"
            element={user ? <Dashboard /> : <Navigate to="/" />}
          />
        </Routes>

        {/* Լոգինի Մոդալը */}
        {isAuthModalOpen && (
          <Modal onClose={() => setIsAuthModalOpen(false)}>
            <Login
              onLogin={handleLogin}
              currentSectionId={getCurrentSectionId()}
            />
          </Modal>
        )}

       
      </div>
    </AuthContext.Provider>
  );
}

export default App;